import { apiService } from '../api';
import { Session, SessionStatus } from '../../types/sessions';

export interface CreateSessionInput {
  name: string;
  startDate: string;            // ISO
  endDate: string;              // ISO
}

export interface UpdateSessionInput {
  name?: string;
  startDate?: string;
  endDate?: string;
}

export const sessionsApi = {
  list: async (filter?: { status?: SessionStatus; includeArchived?: boolean }) => {
    const response = await apiService.get<Session[]>('/sessions', filter);
    return response.data ?? [];
  },

  getActive: async () => {
    const response = await apiService.get<Session | null>('/sessions/active');
    return response.data ?? null;
  },

  get: async (id: string) => {
    const response = await apiService.get<Session>(`/sessions/${id}`);
    return response.data!;
  },

  create: async (input: CreateSessionInput) => {
    const response = await apiService.post<Session>('/sessions', input);
    return response.data!;
  },

  update: async (id: string, input: UpdateSessionInput) => {
    const response = await apiService.put<Session>(`/sessions/${id}`, input);
    return response.data!;
  },

  activate: async (id: string) => {
    const response = await apiService.post<Session>(`/sessions/${id}/activate`);
    return response.data!;
  },

  complete: async (id: string) => {
    const response = await apiService.post<Session>(`/sessions/${id}/complete`);
    return response.data!;
  },

  archive: async (id: string) => {
    const response = await apiService.post<Session>(`/sessions/${id}/archive`);
    return response.data!;
  }
};
